const { instance } = require('./url')

async function getDrawingData(quoteId) {
    return await instance.get('/drawingdata/' + quoteId)
}

async function updateDrawingData(
    signId, font, mounting, partData, dimensionScale, overviewScale,
) {
    return await instance.put('/drawingdata/' + signId, {
        'font': font,
        'mounting': mounting,
        'part_data': partData,
        'dimension_scale': dimensionScale,
        'overview_scale': overviewScale,
    })
}

async function updateDrawingDataBatch(updates) {
    return await instance.put('/drawingdata/batch', {
        'updates': updates,
    })
}

export {
    getDrawingData,
    updateDrawingData,
    updateDrawingDataBatch,
}
